import React from 'react';
import PropTypes from 'prop-types';
import { Card, Badge, Icon, IconButton } from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';
import { getLocalizedValue } from '../../helpers/localizationUtils';
import './FavoriteReportCard.css';

function FavoriteReportCard({ report, onRemove, onClick }) {
  const reportName = getLocalizedValue(report.name);
  const reportDesc = getLocalizedValue(report.desc);
  const visibility = report.permissions?.visibility;
  const statusColor = report.status === 'published' ? 'success' : 'default';

  return (
    <Card
      headerStart={<strong>{reportName}</strong>}
      headerEnd={
        <IconButton
          icon="trash"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(report.favoriteId);
          }}
          ariaLabel="Remove from favorites"
        />
      }
      onClick={() => onClick(report.id)}
      className="favorite-report-card"
    >
      <div className="favorite-report-card-content">
        <div className="report-info">
          <div className="report-type">
            <Icon icon="document" size="small" />
            <span>{report.builderType}</span>
          </div>
          <div className="report-status">
            <Badge color={statusColor}>
              {report.status}
            </Badge>
          </div>
          {visibility && (
            <div className="report-visibility">
              <Badge color={visibility === 'public' ? 'primary' : 'default'}>
                {visibility}
              </Badge>
            </div>
          )}
        </div>

        {reportDesc && (
          <p className="report-description">{reportDesc}</p>
        )}

        {report.tags && report.tags.length > 0 && (
          <div className="report-tags">
            {report.tags.map((tag, index) => (
              <Badge key={index} color="primary">{tag}</Badge>
            ))}
          </div>
        )}

        {report.notes && (
          <div className="report-notes">
            <Icon icon="comment" size="small" />
            <span>{report.notes}</span>
          </div>
        )}
      </div>
    </Card>
  );
}

FavoriteReportCard.propTypes = {
  report: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

export default FavoriteReportCard;
